



























import { annotationModule, authModule } from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import UserMenu from '@/components/UserMenu.vue';
import { NavigationGuardNext, Route } from 'vue-router';

@Component
export default class AnnotationTab extends Vue {}
